var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMonitor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117.377,
    height: 117.377,
    viewBox: "0 0 117.377 117.377",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -13.19, 17.189)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "color-change",
    cx: 58.688,
    cy: 58.688,
    r: 58.688,
    fill: "#000",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 17.189, -13.19)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.56 44.673a.826.826 0 0 1-.826-.83A4.074 4.074 0 0 1 17.3 39.8l.59-2.7H.826A.832.832 0 0 1 0 36.262V.83A.827.827 0 0 1 .826 0h45.645a.827.827 0 0 1 .83.83v35.432a.832.832 0 0 1-.83.833H29.41L30 39.8a4.076 4.076 0 0 1 3.568 4.045.827.827 0 0 1-.827.83zm.975-1.66h16.232a2.409 2.409 0 0 0-2.257-1.583H17.792a2.407 2.407 0 0 0-2.257 1.583zM19 39.768h9.3l-.585-2.673h-8.127zM1.657 35.432h43.988v-1.591H1.657zm0-3.253h43.988V4.915H1.657zm0-28.926h43.988V1.662H1.657zM14.3 29.319a.835.835 0 0 1-.83-.835v-9.969a3.593 3.593 0 0 1-1.67-3.036v-2.765a.824.824 0 0 1 .147-.472l2.845-4.093a.83.83 0 0 1 .679-.355H31.83a.831.831 0 0 1 .682.355l2.843 4.093a.826.826 0 0 1 .15.472v2.765a3.6 3.6 0 0 1-1.671 3.036v9.969a.832.832 0 0 1-.83.835zm.829-1.668h17.045v-8.587c-.085.008-.168.013-.255.013a3.567 3.567 0 0 1-2.755-1.3 3.575 3.575 0 0 1-5.515 0 3.569 3.569 0 0 1-5.509 0 3.575 3.575 0 0 1-2.758 1.3c-.086 0-.17-.005-.255-.013zm14.864-12.172a1.925 1.925 0 1 0 3.849 0v-1.933h-3.849zm-5.515 0a1.928 1.928 0 1 0 3.855 0v-1.933h-3.852zm-5.511 0a1.926 1.926 0 1 0 3.853 0v-1.933h-3.849zm-5.511 0a1.926 1.926 0 1 0 3.853 0v-1.933h-3.853zm.76-3.6h18.866L31.4 9.456H15.9z",
    transform: "translate(35.038 38.542) translate(0 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMonitor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconMonitor.692b14d7.svg";
export { ForwardRef as ReactComponent };